import { useNavigate } from "react-router-dom";
import { PortalSidebar, type SidebarNavSection } from "@/shared/layout/PortalSidebar";
import { SidebarProfileCard } from "@/shared/layout/SidebarProfileCard";
import { useClinicianAuthStore } from "@/stores/clinicianAuthStore";
import { getInitials } from "./getInitials";

const navSections: SidebarNavSection[] = [
  {
    title: "Overview",
    items: [
      // Also covers an item opened from My Items (/clinician/my-items/:id).
      { path: "/clinician/my-items", label: "My Items", icon: "lucide:briefcase-medical" },
      {
        path: "/clinician",
        label: "Review Queue",
        icon: "lucide:clipboard-list",
        // An item opened from here (/clinician/review/:id) keeps it highlighted; My Items doesn't.
        isActive: (pathname) => pathname === "/clinician" || pathname.startsWith("/clinician/review/"),
      },
    ],
  },
];

interface ClinicianSidebarProps {
  name: string;
}

export function ClinicianSidebar({ name }: ClinicianSidebarProps) {
  const signOut = useClinicianAuthStore((s) => s.signOut);
  const navigate = useNavigate();

  const handleSignOut = () => {
    void signOut();
    navigate("/clinician/login", { replace: true });
  };

  return (
    <PortalSidebar
      logoTitle="MedSyncIQ"
      logoSubtitle="Clinician Portal"
      profileSlot={
        <SidebarProfileCard
          avatarInitials={getInitials(name)}
          name={name}
          detailsLine="Clinician Account"
          showChevron={false}
        />
      }
      navSections={navSections}
      onSignOut={handleSignOut}
    />
  );
}
